import React, { useState, useEffect } from 'react';
import Header from '../Header/Header';
import Sidebar from '../Sidebar/Sidebar';
import TrialBanner from '../../subscriptions/TrialBanner/TrialBanner';
import { useAuth } from '../../../hooks/useAuth';

interface PageContainerProps {
  children: React.ReactNode;
  title?: string;
  titleIcon?: React.ReactElement;
}

const PageContainer: React.FC<PageContainerProps> = ({ children, title, titleIcon }) => {
  const { isAuthenticated } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  useEffect(() => {
    if (sidebarOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    
    return () => {
      document.body.style.overflow = '';
    };
  }, [sidebarOpen]);
  
  return (
    <div className="flex flex-col min-h-screen bg-off-white">
      <Header onMenuClick={toggleSidebar} />
      {isAuthenticated && <TrialBanner />}

      <div className="flex relative">
        {isAuthenticated && (
          <>
            {/* Mobile sidebar backdrop */}
            {sidebarOpen && (
              <div 
                className="fixed inset-0 bg-gray-600 bg-opacity-75 z-20 md:hidden"
                onClick={() => setSidebarOpen(false)}
              />
            )}
            
            {/* Sidebar for mobile (off-canvas) */}
            <div className={`fixed inset-y-0 left-0 transform ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'} transition-transform duration-300 ease-in-out z-30 md:hidden`}>
              <Sidebar onCloseSidebar={() => setSidebarOpen(false)} />
            </div>
          </>
        )}
        
        {/* Main content */}
        <main className="flex-1 p-3 md:p-6 w-full">
          {title && (
            <div className="mb-4 md:mb-8 flex items-center">
              {titleIcon && React.cloneElement(titleIcon, { className: 'h-5 w-5 md:h-6 md:w-6 mr-2 md:mr-3 text-primary flex-shrink-0' })}
              <h1 className="text-xl md:text-3xl font-bold text-primary truncate">{title}</h1>
            </div>
          )}
          
          {children}
        </main>
      </div>
    </div>
  );
};

export default PageContainer; 